import { createContext } from "react";

import type { ProfileContextValue } from "./ProfileContextProvider";

export const ProfileContext = createContext<ProfileContextValue | null>(null);

ProfileContext.displayName = "ProfileContext";
